import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import s from './docs.module.css'
import SaveStatus from '../../UIComponents/SaveStatus'
import StatusManager from '../../UIComponents/StatusManager'
import { DataGrid } from '@mui/x-data-grid';
import { Button, Typography, } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import PreviewIcon from '@mui/icons-material/Preview';
import PostAddIcon from '@mui/icons-material/PostAdd';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// import ModalDialog from '../../UIComponents/ModalDialog';
import ModalDeleteConfirm from '../../UIComponents/ModalDeleteConfirm/ModalDeleteConfirm';
// import GeoIconArray from '../GeoIconArray';

import useStyles from './useStyles';

import mapStateToProps from './mapStateToProps'


const DocumentSheduleBody = (props) => {
  const {
    documents = [],
    rights,
  } = props

  const history = useHistory()

  const [operableId, setOperableId] = useState(undefined);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const tmpDataHolder = useRef(null)

  const {
    documentData,
    deletingDocument,
    changingStatusDocument,
    shorts: { planScheduleStatuses: statuses } = {},

    deleteDocument = () => { },
    changeStatusDocument = () => { },
    setDocumentData = () => { },
  } = useSelector(mapStateToProps);

  const classes = useStyles();

  const hasActions = true

  const changeStatus = (id, status) => {
    tmpDataHolder.current = status;
    setOperableId(id);
    changeStatusDocument({
      docId: "planSchedule",
      id,
      status
    })
  }

  const onPressDelete = (id) => {
    setShowDeleteDialog(true)
    setOperableId(id);
  }

  const hideDeleteDialog = () => {
    setShowDeleteDialog(false)
    setOperableId(undefined);
  }
  const dataDelete = () => {
    deleteDocument({
      docId: "planSchedule",
      id: operableId
    })
  }
  const onItemDeleted = () => {
    removeItem(operableId)
    setOperableId(undefined);
  }

  const removeItem = (id) => {
    const { data = [] } = documentData;
    const newData = data.filter((row) => row?.id.rawValue !== id)
    const newDocumentData = { ...documentData, data: newData }
    setDocumentData(newDocumentData)
  }

  const onStatusChanged = () => {
    updateStatus(operableId, tmpDataHolder.current);
    tmpDataHolder.current = null;
    setOperableId(undefined);
  }

  const updateStatus = (id, status) => {
    const { data = [] } = documentData;
    const newData = data.map((row) => {
      if (row?.id?.rawValue === id) {
        //заменяем статус
        const newRow = { ...row, status: { value: status, rawValue: status } };
        return newRow
      } else {
        //возвращаем без изменений
        return row
      }
    })
    const newDocumentData = { ...documentData, data: newData }
    setDocumentData(newDocumentData)
  }

  if (!(rights?.['plan-view'] || rights?.['plan-create'] || rights?.['plan-edit'] || rights?.['plan-delete'])) return null;

  const columns = [
    { field: 'id', headerName: 'Nпп', width: 60 },
    { field: 'number', headerName: 'Номер', width: 90 },
    { field: 'date', headerName: 'Дата документа', width: 150 },
    { field: 'company', headerName: 'Компания', width: 200 },
    { field: 'project', headerName: 'Проект', width: 200 },
    { field: 'periodFrom', headerName: 'Период с', width: 110 },
    { field: 'periodTo', headerName: 'По', width: 110 },
    {
      field: 'status', headerName: 'Статус', width: 200,
      renderCell: ({ row }) => {
        const {
          id,
          status,
          availableStatuses
        } = row;

        /*
            docId,
            documentName,
            currentStatus,
            awailableStatuses,
            statusDirectory=[],
        */
        return (
          <StatusManager
            docId={id}
            documentName="planSchedule"
            currentStatus={status}
            awailableStatuses={availableStatuses}
            statusDirectory={statuses}
          />
        )

      }
    },
    {
      field: 'dataArrLength', headerName: 'Работ', width: 90,
      renderCell: ({ row }) => {
        const {
          dataArrHint,
          dataArrLength
        } = row;

        /*
            docId,
            documentName,
            currentStatus,
            awailableStatuses,
            statusDirectory=[],
        */
        return (
          <Tooltip title={dataArrHint}>{dataArrLength}</Tooltip>
        )

      }
    },
  ];

  const addDoc = () => {
    //добавление
    history.push('/document/schedule/add')
  }
  const editDoc = (id) => {
    history.push(`/document/schedule/edit/${id}`)

  }
  // const deleteDoc = (id) => { }
  const viewDoc = (id) => {
    history.push(`/document/schedule/view/${id}`)
  }

  const actionsCreator = {
    field: '___actions',
    headerName: 'Операции',
    sortable: false,
    width: 370,
    renderCell: ({ row })=> {
      const { id, status} = row
      
      return (
        <>
          {!!rights?.['plan-delete'] ? (
            <Button
              variant="contained"
              size="small"
              color='error'
              startIcon={<DeleteIcon />}
              onClick={() => onPressDelete(id)}
              style={{ marginLeft: 4 }}
              disabled={operableId !== undefined || [4,5,6,7,10,11].includes(status)} //отключаем доступ к кнопкам "удалить" когда показан модальный диалог удаления
            >
              Удалить
            </Button>
          ) : null}
          {!!rights?.['plan-edit'] ? (
            <Button
              variant="contained"
              size="small"
              color='primary'
              onClick={() => editDoc(id)}
              startIcon={<ModeEditIcon />}
              style={{ marginLeft: 4 }}
              disabled={[4,5,6,7,10,11].includes(status)}
            // disabled={!hasEditActions}
            >
              Изменить
            </Button>
          ) : null}
          <Button
            variant="outlined"
            size="small"
            color='primary'
            onClick={() => viewDoc(id)}
            startIcon={<PreviewIcon />}
            style={{ marginLeft: 4 }}
          // disabled={!hasEditActions}
          >
            Просмотр
          </Button>
        </>
      )
    },
  }

  return (
    <div className={s.docsContainer} style={{ width: "100%" }}>
      {showDeleteDialog ? (
        <ModalDeleteConfirm
          key="edit_dialog"
          update={onItemDeleted}
          onClose={hideDeleteDialog}
          open={true}
          saver={dataDelete}
          progressObj={deletingDocument}
        />
      ) : null}
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>
          <Typography variant='h3'>План-график</Typography>
          <SaveStatus
            errShowTime={1000}
            successShowTime={100}
            dataObj={changingStatusDocument}
            title="Изменение статуса"
            postSuccessAction={onStatusChanged}
          />
        </div>
      </div>

      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>
          {!!rights?.['plan-create'] ? (
            <Button
              onClick={() => addDoc()}
              variant="contained"
              size="small"
              color='primary'
              startIcon={<PostAddIcon />}
              style={{ marginLeft: 16 }}
            >
              Добавить
            </Button>
          ) : null}
        </div>
      </div>
      <div className={s.secondRightConrainer}>
        <div className={s.contentContainer}>
          {(documents) ? (
            <DataGrid columns={hasActions ? [...columns, actionsCreator] : columns} rows={documents} />
          ) : null}
        </div>
        {/* <BodyRight /> */}
      </div>

    </div>
  );
};


export default DocumentSheduleBody;